import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, Injector } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { PurchaseOrderListing, PurchaseOrderSummary } from '~/models/modules/purchaseOrder';
import { PageNames } from '~/models/pageNames';
import { ApiServiceBase, API_NAMES } from '~/services/api';
import { Pages } from '~/shared/enums/itemsTypes';

@Injectable({ providedIn: 'root' })
export class PurchaseOrdersService extends ApiServiceBase {
  purchaseOrdersClosed: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.stocks);
  }

  getPurchaseOrder(id: number, pageName: string = PageNames.PurchaseOrders) {
    return this.http.get<PurchaseOrderSummary>(this._url(`/${id}/${pageName}`));
  }

  getPurchaseOrderListingBySite(siteId: number) {
    return this.http.get<PurchaseOrderListing[]>(this._url(`/site/${siteId}`));
  }
  getOpenApprovedPurchaseOrderListingBySite(siteId: number) {
    return this.http.get<PurchaseOrderListing[]>(this._url(`/openApprovedPO/site/${siteId}`));
  }



  ApproveRejectSalesOrder(id: number, model: any) {
    return this.client.put(this._url(`/${id}/Status`), model);
  }


  SubmitSalesOrder(model: any) {
    return this.client.put(this._url(`/Submit`), model);
  }

  getPurchaseOrders(paramsObj?: any, model?: any, screenSiteId?: number) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    paramsObj.screenSiteId = screenSiteId;
    let params = createHttpParams(paramsObj);

    return this.http
      .post<PurchaseOrderSummary[]>(this._url(`/grid-data`), model, {
        params,
        observe: 'response',
      })
      .pipe(map(augmentPaging));
  }
  getPurchaseOrdersGridBySite(siteId: number, paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http
      .post<PurchaseOrderSummary[]>(this._url(`/site/${siteId}/grid-data`), model, {
        params,
        observe: 'response',
      })
      .pipe(map(augmentPaging));
  }

  GetPurchaseOrderByStockItem(stockItemId: number, model: any, paramsObj?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http
      .post<PurchaseOrderSummary[]>(this._url(`/StockItems/${stockItemId}/grid-data`), model, {
        params,
        observe: 'response'
      })
      .pipe(map(augmentPaging));
  }


  GetPurchaseOrdersByVendor(vendorId: number, model: any) {
    return this.http
      .post<PurchaseOrderSummary[]>(this._url(`/Vendors/${vendorId}/grid-data`), model, {
        observe: 'response'
      })
      .pipe(map(augmentPaging));
  }


  GetPurchaseOrderBackOrderByVendor(vendorId: number, model: any) {
    return this.http
      .post<PurchaseOrderSummary[]>(this._url(`/Vendors/${vendorId}/PoBackOrder/grid-data`), model, {
        observe: 'response'
      })
      .pipe(map(augmentPaging));
  }



  createPurchaseOrder(model: any) {
    return this.client.post<string>(this._url(), model);
  }

  updatePurchaseOrder(id: number, model: any) {
    return this.client.put(this._url(`/${id}`), model);
  }

  updatePurchaseOrderStatus(id: number, model: any) {
    return this.client.put(this._url(`/status/${id}`), model);
  }

  deletePurchaseOrder(id: number) {
    return this.client.delete(this._url(`/${id}`));
  }

  deactivatePurchaseOrder(obj: any) {
    return this.client.put(this._url(`/deactivate`), obj);
  }

  reactivatePurchaseOrder(obj: any) {
    return this.client.put(this._url(`/reactivate`), obj);
  }

  reactivateDeactivateBatchPurchaseOrder(obj: any) {
    return this.client.put(this._url(`/batchActivateDeactivate`), obj);
  }


  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/PurchaseOrders${v}`);
  }

  purchaseOrdersFormClosed(newValue: any) {
    this.purchaseOrdersClosed.next(newValue);
  }


}
